<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
   <h5 style="font-weight:bold;">Upload Document</h5>
  	<card>
  	
  	  <div class="col-sm-7" >    
                 <fg-input type="text"
                  name="document name"
				  label="Document Name"                  
                  v-model="new_key_document.document_name">
       			 </fg-input>
            </div>
            
            
            
       
          <div class="col-sm-7">
      	   <fg-input label="Folder"   >
                  <el-select class="select-primary"
                             size="large"
                              
                             placeholder="Select Folder"
                             v-model="new_key_document.folder_id">
                    <el-option v-for="option in folders"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
                </div>
                
             <div class="row" style="padding:20px 0px;">
			  <label class="col-sm-2 col-form-label">Tags</label>
			  <div class="col-sm-7">
					<div v-for="tag in tags" >
          	
					<p-checkbox style="margin-bottom:15px;margin-top:15px;" :id="tag.id" :value="tag.id" 
					 v-model="selectedTags['t'+tag.id]">
	
						<span  style="color:#000">{{tag.tag_name}}</span>
						</p-checkbox>
				  </div>
				
				
			  </div><!-- end right col -->
			</div>
                
            
        	
        	
        	<!--
        	<div class="col-sm-7">    
                 <fg-input type="text"
                  name="remarks"
				  label="Remarks"                  
                  v-model="new_key_document.remarks">
       			 </fg-input>
            </div>-->
        	
        	<div style="margin-top:30px;"><input type="file" id="file" ref="new_file" class="btn btn-default" /></div>
        	
        	<p-button    @click.prevent="uploadKeyDocFile()" type="info" style="width:100%;">
   				 <i slot="label" class="nc-icon nc-cloud-upload-94"></i>
           				Upload File
   			 </p-button> 
        </card>
        
        
        
        
	       
	       
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.loadMailbox();
    },
    
     
    data () {
      return {
        coy:[],
        docs:[],
        key_docs:[],
        folders:[],
        tags:[],
        selectedTags:[],
        selectedTagsArr:[],
        new_key_document:{folder_id:0},
      //  folder_id:0,
        folder:{},
        has_key_docs: false,
    	eid: this.$route.params.eid,
		 new_mail: {
          document_name: '',
          notes:'',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    loadMailbox(){
	    	let uri = this.$base_url+'/api/v1/documents/upload_doc_get_folders/entity/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.folders = response.data.folders;
				
				let vm = this;
				//for tags
				this.tags = response.data.tags;
		
				response.data.tags.forEach(function(tag){
						if(tag){
								vm.selectedTags["t"+tag.id] = false;
						 }
				 });

			})
	    },
	    viewDocument(did){
	    	this.$router.push( '/view-document/'+did+"/1");
	    
	    },
	    viewFolder(eid, dfid){
	    	this.$router.push( '/view-folder/'+dfid+"/entity/"+eid);
	    },
	    goToEntityDocuments(){
      		 this.$router.push( '/entity-documents/'+this.$route.params.eid)  
       },
	   uploadKeyDocFile(){
	   		
    	 	   if(!this.$refs.new_file.files[0]){
    	 	   
    	 	   	return false;
    	 	   }
    	 
    	 
    	 		if( !this.new_key_document.document_name){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for this document.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 
    	 		 const vm = this;
    	 		 //get tags:
				vm.selectedTagsArr = [];
			
				var tags_1 = this.tags;
				tags_1.forEach(function(t){
					if(vm.selectedTags["t"+t.id]==true){
						vm.selectedTagsArr.push(t.id);
					}
				});
				
				
    	 		swal.showLoading();
      			let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    formData.append('kd_folder_id', this.new_key_document.folder_id);
  			    formData.append('kd_tags',  this.selectedTagsArr.toString());
  			    formData.append('kd_document_name', this.new_key_document.document_name);
  			    formData.append('kd_remarks', this.new_key_document.remarks);
  			    
  			   
  			    if(this.new_key_document.document_name ==""){
  			    	this.new_key_document.document_name = '-';
  			    }
  			    
  			   
			
			
  			    
  			     let uri = this.$base_url+'/api/v1/documents/upload_new_doc/entity/'+ this.$route.params.eid;
				 ApiService.post(uri,formData).then(response => {
						swal({
						  title: 'Uploaded.',
						  text: 'The file has been uploaded.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
								swal.close();
								
								
								vm.$router.push( '/entity-documents/'+vm.$route.params.eid)  
						})//end swal
			
				  })
      	
      	
      	},
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


